export default __webpack_public_path__ + "static/media/Thankyou_Background.0a056475.svg";